module.exports = __webpack_public_path__ + "img/welcome-to-ditto-8.696b488c.png";